"use client";
import { ReactNode, useEffect, useState } from "react";
import LoadingPage from "../LoadingPage/LoadingPage";
import makeAsyncScriptLoader from "react-async-script";
import ReCAPTCHA from "react-google-recaptcha";
import { validateCaptcha } from "@/services/GoogleService";
import { YOUTUBE_VIDEO_URL } from "@/constants/texts";
const cantina = "../../assets/images/cantina.jpeg";
const AsyncRecaptcha = makeAsyncScriptLoader(
  "https://www.google.com/recaptcha/api.js"
)(ReCAPTCHA);
const kalebLogo = "../../assets/images/LOGO.svg";
function VisitValidation({
  children,
  captchaKey,
}: {
  children: ReactNode;
  captchaKey: string;
}) {
  const [validation, setValidation] = useState<boolean>(false); //prevent yoda
  const [loading, setLoading] = useState<boolean>(true);
  const [captchaResetKey, setCaptchaResetKey] = useState<number>(0);
  const handleRecaptcha = async (value: any) => {
    if (value) {
      try {
        const res = await validateCaptcha(value);
        if (res.success) {
          const userAgent = navigator.userAgent;
          localStorage.setItem("userAgent", userAgent);
          window.location.reload();
        } else {
          console.error(
            "Captcha verification failed or suspicious activity detected."
          );
          setCaptchaResetKey((prev) => prev + 1);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    const savedUserAgent = localStorage.getItem("userAgent");
    if (savedUserAgent === navigator.userAgent) {
      setValidation(true);
    }
    setLoading(false);
  }, []);
  return (
    <>
      {loading && <LoadingPage />}
      {!validation && (
        <div
          className="flex flex-col overflow-auto fixed z-[1100] p-8 bg-[#030812] top-0 left-0 w-full h-full items-center"
          style={{ gap: 20 }}
        >
          <img
            className="w-full max-w-[250px] xl:max-w-[300px]"
            src={kalebLogo}
            alt="logo"
          />
          <div className="flex gap-2 lg:flex-row flex-col items-center">
            <div className="text-white text-center">
              <p style={{ fontSize: "1.8rem" }} className="text-lg">
                CelebStory is a Wiki-based Humanity Almanac.
              </p>
              <p style={{ fontSize: "1.8rem" }} className="text-lg">
                Each photo is attached to a date and displayed in chronological
                order as a smooth story.
              </p>
              <p style={{ fontSize: "1.8rem" }} className="text-lg">
                Upload photos or share your referral link to gain points.
              </p>
              <p style={{ fontSize: "1.8rem" }} className="text-lg">
                Later these points will be converted into CelebStory NFTs,
              </p>
              <p style={{ fontSize: "1.8rem" }} className="text-lg">
                supported by the value of the whole resource, and can be sold
                for profit.
              </p>
              <hr></hr>
              <p style={{ textDecoration: "underline" }}>
                Check ‘About’ for the details.
              </p>
              {/*	<p>Points can be spent on uploading to the Special category.</p>*/}
            </div>
            <img
              src={cantina}
              alt="cantina star wars"
              className="cantina lg:flex hidden"
              style={{ maxWidth: 500 }}
            />
          </div>{" "}
          <AsyncRecaptcha
            key={captchaResetKey}
            sitekey={captchaKey}
            onChange={handleRecaptcha}
            asyncScriptOnLoad={() => console.log("Script loaded")}
          />
          <div className="w-full max-w-[600px] mt-auto">
            <iframe
              src={`${YOUTUBE_VIDEO_URL}?si=nv4o_3lZJQ0flSdp`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="w-full h-auto aspect-video"
            ></iframe>
          </div>
        </div>
      )}
      {children}
    </>
  );
}

export default VisitValidation;
